import { render, staticRenderFns } from "./ManageChange.vue?vue&type=template&id=0e57047d&"
import script from "./ManageChange.vue?vue&type=script&lang=js&"
export * from "./ManageChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports